/**
 * @file WorkPattern class is a wrapper of PlanItem from the backend api towards the Agenda.
 * @author Maarten Lensink
 */
import * as tslib_1 from "tslib";
import { PlanItemWrapper } from './plan-item-wrapper';
/** AgendaWorkPattern class is a wrapper of the PlanItem entity containing a WorkPattern entity. */
var AgendaWorkPattern = /** @class */ (function (_super) {
    tslib_1.__extends(AgendaWorkPattern, _super);
    /**
     * Constructs an AgendaWorkPattern.
     * @param item The PlanItem being wrapped.
     */
    function AgendaWorkPattern(item) {
        return _super.call(this, item) || this;
    }
    /**
     * Gets the appropriate collection of the given timeslot for this AgendaWorkPattern class.
     */
    AgendaWorkPattern.prototype.getCollectionOf = function (timeSlot) {
        return timeSlot.gridWorkPatterns;
    };
    /**
     * Create a copy of this instance.
     */
    AgendaWorkPattern.prototype.makeCopy = function () {
        var copy = new AgendaWorkPattern(this.item);
        copy.covers = this.covers;
        copy.zIndex = this.zIndex;
        return copy;
    };
    return AgendaWorkPattern;
}(PlanItemWrapper));
export { AgendaWorkPattern };
